"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _IframeConfigJson = _interopRequireDefault(require("./IframeConfig.json.js"));

var _EasingAnimation = _interopRequireDefault(require("../animation/EasingAnimation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DEFAULT_SCROLL_OPTIONS = {
  element: null,
  platform: null,
  animate: true,
  center: true,
  minDistance: 200,
  scrollTopMargin: 10
};
/**
 * This class is used for calculating the application size when inside an iframe.
 */

var IframeUtility = /*#__PURE__*/function () {
  function IframeUtility() {
    _classCallCheck(this, IframeUtility);
  }

  _createClass(IframeUtility, null, [{
    key: "calculateHeight",

    /**
     * Calculates the application height based on width and platform.
     *
     * @param {object} width Application width.
     * @param {string} [platform] Application plattform (nwp or irw). Default is "irw".
     * @returns {number} Calculated height.
     */
    value: function calculateHeight(width) {
      var platform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'irw';

      var screen = this._getScreen(width);

      var deviceType = this._calculateDeviceType(screen.width, screen.orientation);

      var appWidth = Math.min(width, _IframeConfigJson.default.maxWidth);

      var availableHeight = this._getAvailableHeight(screen.height, platform, deviceType);

      var height = appWidth / this._getRatio(screen.orientation);

      height = Math.min(height, availableHeight, _IframeConfigJson.default.maxHeightLandscape);

      if (screen.orientation === _IframeConfigJson.default.orientation.landscape) {
        height = Math.max(height, this._getMinHeightLandscape(deviceType, appWidth));
      }

      return Math.floor(height);
    }
    /**
     * Returns the device type based on the application size.
     *
     * @returns {string} Device type (mobile, desktop or tablet).
     */

  }, {
    key: "getDeviceType",
    value: function getDeviceType() {
      var minMeasurement = Math.min(window.screen.availWidth, window.screen.availHeight);
      return this._calculateDeviceType(minMeasurement, _IframeConfigJson.default.orientation.portrait);
    }
    /**
     * Returns the current orientation based on width.
     *
     * @param {number} width Application width.
     * @returns {string} Orientation (landscape or portrait).
     */

  }, {
    key: "getOrientation",
    value: function getOrientation(width) {
      return this._getScreen(width).orientation;
    }
    /**
     * Returns the header height.
     *
     * @param {string} platform Platform (nwp, irw, m2, mobile etc.).
     * @returns {number} Available height.
     */

  }, {
    key: "getHeaderHeight",
    value: function getHeaderHeight(platform) {
      // Is KOMPIS
      if (window.getIframeComponent) {
        return window.screen.width < 1024 ? 52 : 72;
      }

      return platform === 'nwp' ? _IframeConfigJson.default.nwpHeaders[this.getDeviceType()] : 0;
    }
    /**
     * Scrolls the parent window to make the element visible.
     *
     * @param {object} options Options object.
     * @param {Element} options.element Element to scroll into view.
     * @param {string} options.platform Platform (nwp, irw, m2, mobile etc.).
     * @param {boolean} [options.animate] TRUE to animate. Default is TRUE.
     * @param {boolean} [options.center] TRUE to center the element. Default is TRUE.
     * @param {number} [options.minDistance] Minimal distance before scroll will be activated. Default is "200" (px).
     * @param {number} [options.scrollTopMargin] Scroll top margin that will be offset from the top of the element when the element height is greater than the screen height. Default is "10" (px);.
     * @returns {EasingAnimation|null} Returns the easing animation if "animate" has been set to "true".
     */

  }, {
    key: "scrollToElement",
    value: function scrollToElement(options) {
      options = Object.assign({}, DEFAULT_SCROLL_OPTIONS, options);

      if (this.isInsideIframe()) {
        var screenHeight = window.parent.innerHeight;
        var headerHeight = this.getHeaderHeight(options.platform);
        var availableScreenHeight = screenHeight - headerHeight;

        var parentScrollPosition = this._getScrollPosition(window.parent);

        var scrollY = parentScrollPosition.y;
        var iframeTop = window.frameElement.getBoundingClientRect().top + scrollY - headerHeight;
        var elementTop = options.element.getBoundingClientRect().top + this._getScrollPosition().y + iframeTop;
        var elementHeight = options.element.offsetHeight;
        var centeredElementScrollY = elementHeight > availableScreenHeight ? elementTop - options.scrollTopMargin : elementTop - screenHeight / 2 + headerHeight + elementHeight / 2 - options.scrollTopMargin;
        var elementScrollY = options.center ? centeredElementScrollY : elementTop + headerHeight - options.scrollTopMargin;
        var newScrollY = elementScrollY > 0 ? elementScrollY : 0;
        var distanceY = newScrollY < scrollY ? scrollY - newScrollY : newScrollY - scrollY;

        if (options.animate) {
          var frames = Math.floor(distanceY / 10);

          if (distanceY > options.minDistance || elementHeight > availableScreenHeight) {
            var animation = new _EasingAnimation.default();
            animation.on('frame', function (y) {
              return window.parent.scrollTo(parentScrollPosition.x, y);
            });
            animation.startValue = scrollY;
            animation.endValue = newScrollY;
            animation.frames = frames;
            animation.start();
            return animation;
          }
        } else {
          window.parent.scrollTo(parentScrollPosition.x, newScrollY);
        }
      }

      return null;
    }
    /**
     * Checks if the application is inside an iframe.
     *
     * @returns {boolean} TRUE if inside an iframe.
     */

  }, {
    key: "isInsideIframe",
    value: function isInsideIframe() {
      try {
        if (window.parent && window.parent.innerHeight && window.frameElement && window.self !== window.top) {
          return true;
        }
      } catch (error) {// Ignore error
      }

      return false;
    }
    /**
     * Returns parent scroll position.
     *
     * @param {object} frame Frame object. Defaults to "window".
     * @returns {{y: number, x: number}} Scroll position.
     */

  }, {
    key: "_getScrollPosition",
    value: function _getScrollPosition() {
      var frame = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
      return {
        y: frame.pageYOffset !== undefined ? frame.pageYOffset : frame.document.documentElement.scrollTop,
        x: frame.pageXOffset !== undefined ? frame.pageXOffset : frame.document.documentElement.scrollLeft
      };
    }
    /**
     * Returns the current screen data: width, height and orientation.
     *
     * @param {number} width Application width.
     * @returns {object} Screen setup.
     */

  }, {
    key: "_getScreen",
    value: function _getScreen(width) {
      var screen = {};
      /*
       * Some devices may return same availWidth/availHeight despite rotation
       * using given iframe width and assuming that it will not be greater that the actual screen width,
       * we can assume that we are in portrait if the iframe width is smaller or same as the smallest of the values
       */

      if (width <= Math.min(window.screen.availWidth, window.screen.availHeight, _IframeConfigJson.default.minWidthLandscape)) {
        screen.width = Math.min(window.screen.availWidth, window.screen.availHeight);
        screen.height = Math.max(window.screen.availWidth, window.screen.availHeight);
        screen.orientation = _IframeConfigJson.default.orientation.portrait;
      } else {
        screen.width = Math.max(window.screen.availWidth, window.screen.availHeight);
        screen.height = Math.min(window.screen.availWidth, window.screen.availHeight);
        screen.orientation = _IframeConfigJson.default.orientation.landscape;
      }

      return screen;
    }
    /**
     * Returns the available height.
     *
     * @param {number} screenHeight The screen height.
     * @param {string} platform Platform (nwp or irw).
     * @param {string} deviceType Device type (mobile, desktop or tablet).
     * @returns {number} Available height.
     */

  }, {
    key: "_getAvailableHeight",
    value: function _getAvailableHeight(screenHeight, platform, deviceType) {
      var bannerHeight = platform === 'nwp' ? _IframeConfigJson.default.nwpHeaders[deviceType] : 0;
      return screenHeight - _IframeConfigJson.default.unavailableHeight[deviceType] - bannerHeight;
    }
    /**
     * Calculates the device type.
     *
     * @param {number} screenWidth The screen width.
     * @param {string} orientation Orientation (portrait or landscape).
     * @returns {string} Device type (mobile, desktop or tablet).
     */

  }, {
    key: "_calculateDeviceType",
    value: function _calculateDeviceType(screenWidth, orientation) {
      if (screenWidth < _IframeConfigJson.default.screenWidthLimits[orientation][_IframeConfigJson.default.deviceType.mobile]) {
        // largest known phone is 736 (iPhone 6+), smallest known tablet is 1024 (iPad)
        return _IframeConfigJson.default.deviceType.mobile;
      }

      if (screenWidth <= _IframeConfigJson.default.screenWidthLimits[orientation][_IframeConfigJson.default.deviceType.tablet]) {
        // tablets larger than this may use full desktop ui
        return _IframeConfigJson.default.deviceType.tablet;
      }

      return _IframeConfigJson.default.deviceType.desktop;
    }
    /**
     * Returns the minimal possible height when in landscape.
     *
     * @param {string} deviceType Device type (mobile, desktop or tablet).
     * @param {number} appWidth Application width.
     * @returns {number} Minimal height for landscape.
     */

  }, {
    key: "_getMinHeightLandscape",
    value: function _getMinHeightLandscape(deviceType, appWidth) {
      if (deviceType == _IframeConfigJson.default.deviceType.mobile) {
        return appWidth / _IframeConfigJson.default.maxRatioLandscape;
      }

      return _IframeConfigJson.default.minHeightLandscape;
    }
    /**
     * Returns the current ratio.
     *
     * @param {string} orientation Orientation (portrait or landscape).
     * @returns {number} Ratio.
     */

  }, {
    key: "_getRatio",
    value: function _getRatio(orientation) {
      var ratio = _IframeConfigJson.default.preferredRatio[orientation].split('/');

      return parseInt(ratio[0]) / parseInt(ratio[1]);
    }
  }]);

  return IframeUtility;
}();

exports.default = IframeUtility;